import { toDate } from '../date/DateExtensions';

export function mapFirestorePostToUIPost(data, id) {
  return {
    id,
    content: data.content,
    currentParticipants: data.activity?.currentParticipants || data.currentParticipants || 0,
    activity: data.activity ? {
      ...data.activity,
      date: toDate(data.activity.date),
      participants: data.activity.participants || [],
      currentParticipants: data.activity.currentParticipants || 0,
      maxParticipants: data.activity.maxParticipants || 8,
      type: data.activity.type,
      typeLabels: data.activity.typeLabels,
      typeIcon: data.activity.typeIcon,
      subtype: data.activity.subtype,
      subtypeLabels: data.activity.subtypeLabels,
      participantsDetails: Array.isArray(data.activity.participantsDetails) ? data.activity.participantsDetails : [],
      location: data.activity.location,
      title: data.activity.title
    } : undefined,
    author: data.author ? {
      uid: data.author.uid,
      name: data.author.name,
      photoURL: data.author.photoURL
    } : {
      uid: 'anonymous',
      name: 'Anonymous'
    },
    createdAt: toDate(data.createdAt),
    visibility: data.visibility || 'everyone',
    participants: data.participants || [],
    saves: data.saves || [],
    shares: data.shares || []
  };
} 